import styled from '@emotion/styled';
import React from 'react';
import Drawer from '@mui/material/Drawer';
import CloseIcon from '@mui/icons-material/Close';
import { __snackBarSeverity, __snackBarText } from '../../constants';
import { Divider } from '@mui/material';
import { getUserPaymentDetails } from '../../Controllers/Payments';

const anchor = "right"; //DIRECTION FRO WHERE DRAWER WILL OPEN

export default function PaymentDetails({ paymentInfo, setPaymentInfo }) {
    const [state, setState] = React.useState({ payment: {}, load: true })

    React.useEffect(() => {
        if (paymentInfo.open)
            fetchPayments()
    }, [paymentInfo.open === true])

    const fetchPayments = async () => { /* Handling api call */
        const res = await getUserPaymentDetails(paymentInfo.id)
        if (res.data.status === 200) {
            setState({ ...state, payment: res.data.data.payment[0], load: false })
        }
    }

    return (
        <React.Fragment>
            <Drawer anchor={anchor} open={paymentInfo.open} onClose={() => setPaymentInfo({ ...paymentInfo, open: false })}>
                {!state.load &&
                    <Container>
                        <>
                            <Header>
                                <h4>Payment details</h4>
                                <CloseIcon className='pointer' onClick={() => setPaymentInfo({ ...paymentInfo, open: false })} />
                            </Header>
                            <Body className='scroll-bar-hidden'>
                                <p className='label'>{paymentInfo.data.jobInfo.displayedJobId}</p>
                                <UserInfo>
                                    <h5 className='section-heading'>Payee Info</h5>
                                    <Divider sx={{ margin: '5px 0px 5px 0' }} />
                                    <InfoBox>
                                        <p className='label'>Name</p>
                                        <p className='label-info'>{state.payment?.payeeInfo[0]?.firstName} {state.payment?.payeeInfo[0]?.lastName}</p>
                                    </InfoBox>
                                    <InfoBox>
                                        <p className='label'>Email</p>
                                        <p className='label-info'>{state.payment?.payeeInfo[0]?.email}</p>
                                    </InfoBox>
                                </UserInfo>
                                <UserInfo>
                                    <h5 className='section-heading'>Payer Info</h5>
                                    <Divider sx={{ margin: '5px 0px 5px 0' }} />
                                    <InfoBox>
                                        <p className='label'>Name</p>
                                        <p className='label-info'>{state.payment?.payerInfo[0]?.firstName} {state.payment?.payerInfo[0]?.lastName}</p>
                                    </InfoBox>
                                    <InfoBox>
                                        <p className='label'>Email</p>
                                        <p className='label-info'>{state.payment?.payerInfo[0]?.email}</p>
                                    </InfoBox>
                                </UserInfo>

                                {/* <UserInfo>
                                    <h5 className='section-heading'>Provider bank Info</h5>
                                    <Divider sx={{ margin: '5px 0px 5px 0' }} />
                                    <InfoBox>
                                        <p className='label'>Account No</p>
                                        <p className='label-info'>---------</p>
                                    </InfoBox>
                                </UserInfo> */}

                                <UserInfo>
                                    <h5 className='section-heading'>Overall Earning Info</h5>
                                    <p className='section-description'>This section provides overall job earning information and may include multiple payment records. The information will be displayed only if all payments are finalized.</p>
                                    <Divider sx={{ margin: '5px 0px 5px 0' }} />
                                    <InfoBox className='flex'>
                                        <p className='label'>Job fee</p>
                                        <p className='label-info'>€ {state.payment?.invoice[0]?.invoiceInfo?.billDetail.seekerView.totalAmount || 0}</p>
                                    </InfoBox>
                                    <InfoBox className='flex'>
                                        <p className='label'>Discount price</p>
                                        <p className='label-info'>€ {state.payment?.invoice[0]?.invoiceInfo?.billDetail.seekerView.discountPrice || 0}</p>
                                    </InfoBox>
                                    <InfoBox className='flex'>
                                        <p className='label'>Net job fee</p>
                                        <p className='label-info'>€ {state.payment?.invoice[0]?.invoiceInfo?.billDetail.seekerView.netAmountAfterDiscount || 0}</p>
                                    </InfoBox>
                                    <InfoBox className='flex'>
                                        <p className='label'>Nona earning</p>
                                        <p className='label-info'>€ {state.payment?.invoice[0]?.invoiceInfo?.billDetail.providerView.totalNonaFee || 0}</p>
                                    </InfoBox>

                                    <InfoBox className='flex'>
                                        <p className='label'>Tip</p>
                                        <p className='label-info'>€ {state.payment?.invoice[0]?.invoiceInfo?.billDetail?.meta.tip || 0}</p>
                                    </InfoBox>
                                    <InfoBox className='flex'>
                                        <p className='label'>Extra charges</p>
                                        <p className='label-info'>€ {state.payment?.invoice[0]?.invoiceInfo?.billDetail?.meta.extraCharges || 0}</p>
                                    </InfoBox>
                                    <InfoBox className='flex'>
                                        <p className='label'>Provider earning(exl. extra charges,tip)</p>
                                        <p className='label-info'>€ {(state.payment?.invoice[0]?.invoiceInfo?.billDetail.providerView.payableAmount) || 0}</p>
                                    </InfoBox>
                                    <InfoBox className='flex'>
                                        <p className='label'>*Transaction charges</p>
                                        <p className='label-info'>€   {state.payment?.invoice[0]?.paypalFeeBreakDown?.paypal_fee.value ? "-" : ""}{state.payment?.invoice[0]?.stripeFeeBreakDown?.application_fee_amount || state.payment?.invoice[0]?.paypalFeeBreakDown?.paypal_fee.value || 0}</p>
                                    </InfoBox>
                                    <Divider />
                                </UserInfo>
                            </Body>
                        </>
                    </Container>}
            </Drawer>
        </React.Fragment>
    )
}

const Container = styled("div")`
    height: 100vh;
    width: 30vw;
    display: flex;
    flex-direction: column;
    padding: 1rem;
    overflow: hidden;
    min-width:300px;
    .active{
        color: var(--nona-theme-color);
    }
    .divider-gap{
        margin: 1rem 0;
    }
`;
const Header = styled("div")`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    h4{
        font-weight: 900;
        font-size: 120%;
    }
    padding-bottom: 0.7rem;
    border-bottom: 1px solid var(--card-border);
`;
const Body = styled("div")`
    margin-top: 1rem;
    height: 100%;
    width: 100%;
    overflow-y: auto;
    overflow-x: hidden;
`;

const UserInfo = styled("div")`
margin-bottom:10px;
.section-heading{
    color : var(--nona-light-blue) !important;
}
.section-description{
    font-size: 12px;
    font-style: italic;
    color: #EEB08C;
    margin: 2px 0;
    font-family: regular;
}
`

const InfoBox = styled("div")`
.label{
    font-size:14px;
    font-family : regular;
}
.label-info{
    font-size:14px;
    font-family : medium; 
    padding:5px 0;
}
margin-bottom:10px;
&.flex{
    display:flex;
    justify-content: space-between;
    margin-bottom : 0px;
}
`